import * as React from 'react';

import { ComplainModalContext } from './context';
import { TComplainModalContext } from './types';
import { ComplainModalContainer } from '../ComplainModalContainer';

export const ComplainModalProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [offerId, setOfferId] = React.useState<number | null>(null);

  const close = React.useCallback(() => setOfferId(null), []);
  const openComplain = React.useCallback((id: number) => setOfferId(id), []);

  const value = React.useMemo<TComplainModalContext>(() => ({ openComplain }), [openComplain]);

  return (
    <ComplainModalContext.Provider value={value}>
      {children}
      <ComplainModalContainer offerId={offerId} onClose={close} />
    </ComplainModalContext.Provider>
  );
};
